import GenericReportMobile from '../_partials/GenericReportMobile';
import { useTranslation } from 'react-i18next';
import { sanitizeHref } from '@wix/da-url';
import SoldProductsTableRowHeadingMobile from './SoldProductsTableRowHeadingMobile';
import { formatDollars } from '@wix/da-shared-react/pkg/utils/formatting';

import s from './SoldProductsMobile.scss';

export default function SoldProductsMobile() {
  const { t } = useTranslation();

  const columns = [
    {
      key: 'uniqueProductsSold',
      label: t('studio.reports.section.productSales.table.header.uniqueProductsSold'),
      className: s['products-sold'],
    },
    {
      key: 'totalSales',
      label: t('studio.reports.common.table.header.totalSales'),
    },
    {
      key: 'uniqueCustomers',
      label: t('studio.reports.section.productSales.table.header.customers'),
    },
    {
      key: 'salesVolume',
      label: t('studio.reports.common.table.header.salesVolume'),
      format: formatDollars,
    },
  ];

  return (
    <GenericReportMobile
      reportType="soldProducts"
      headingKey="studio.reports.section.productSales.title"
      descriptionKey="studio.reports.section.productSales.description"
      descriptionTranslationOptions={{
        postProcess: ['reactPostprocessor'],
        learnMoreLink: (
          <a
            className="text-link-level-2-tertiary"
            href={sanitizeHref(
              t('studio.reports.section.productSales.description.learnMoreLink.url')
            )}
          >
            {t('studio.reports.section.productSales.description.learnMoreLink.text')}
          </a>
        ),
      }}
      columns={columns}
      RowHeading={SoldProductsTableRowHeadingMobile}
      showTotal
    />
  );
}
